<p-toast></p-toast>
<div *ngIf="openPdfPreviewModal">
  <app-pdf-preview [resourceUrl]="readOnlyFileUrl" [isPdfPreviewModalShow]="openPdfPreviewModal" 
  (showPdfPreviewModal)="showPdfPreviewModal($event)">
  </app-pdf-preview>
</div>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"> </p-confirmDialog>
<div class="docDetailsScreen" *ngIf="(isDocumentFound && isDocumentVersionFound && isPageFound); else docNotFound">
  <div *ngIf="isRequestedEffectiveDateModal">
    <app-document-request-effective-date-modal
      [documentVersion]="documentDetail.version"
      [documentNumber]="documentDetail.number"
      (isReasonForChangeModalVisible)="
        displayRequestedEffectiveDateModal($event)
      "
    >
    </app-document-request-effective-date-modal>
  </div>
  <div *ngIf="isShowDocumentLinkModal">
    <app-document-link
      [documentDetail]="documentDetail"
      [isDocumentLinkModalOpen]="isShowDocumentLinkModal"
      (isShowDocumentLinkModal)="isShowDocumentLinksModal($event)"
    >
    </app-document-link>
  </div>
  <div *ngIf="isShowDocumentCommentModal">
    <app-document-comment-modal
      [documentComment]="documentDetail.documentComments"
      [openDocumentCommentModal]="isShowDocumentCommentModal"
      (isDocumentCommentModalShow)="isDocumentCommentModalShow($event)"
      [isAddCommentButtonVisible]="documentDetail.isAddCommentButtonVisible"
      [documentNumber]="documentDetail.number"
      [documentVersion]="documentDetail.version"
    >
    </app-document-comment-modal>
  </div>

  <app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
  <div class="documentDetailsContainer">
    <div class="columns toolbar">
      <div class="column1">
        <div *ngIf="documentDetail?.phase!= cancelledDocumentPhaseConstant">
          <em class="blue-color cursor-pointer" (click)="downloadSourceFile(fileId, fileName, documentDetail.printLock ?? false)">
          <em class="fa-solid fa-file fileIconStyle"></em></em>
        </div>
        <div class="overflow-ellipsis" tooltipPosition="bottom" pTooltip="{{ documentDetail?.number }} {{ documentDetail?.title }}" tooltipStyleClass="tooltip">
            <label [ngClass]="{'favoriteIconColor':checkedOutUserInfo===null,'docTitleCheckedOut':checkedOutUserInfo!==null}"  >{{ documentDetail?.number }}</label>
            <label [ngClass]="{'docTitle':checkedOutUserInfo===null, 'docNumberCheckedOut':checkedOutUserInfo!==null}" >{{documentDetail?.title}}</label>          
        </div>                     
        <div class="btn" *ngIf="displayFileCheckedOutIcon">
          <button
            pButton
            pRipple
            type="button"
            id="fileLockInfoIcon"
            pTooltip="Checked Out - {{checkedOutUserInfo}}"
            tooltipPosition="top"
            icon="fa fa-lock fileLockInfoIcon"
            class="p-button-rounded p-button-text fileLockInfoIcon"
          ></button>
        </div>       
        <div class="btn">
          <button appPreventDoubleClick *ngIf="!isDocumentFavourite"
            pButton
            pRipple
            type="button"
            id="favouriteIcon"
            [pTooltip] = getFavouriteToolTip()
            icon="far fa-star favoriteIconColor"
            class="p-button-rounded p-button-text favoriteIconColor"
            (debounceClick)="updateDocumentFavourite()"
          ></button>

          <button appPreventDoubleClick *ngIf="isDocumentFavourite"
            pButton
            pRipple
            type="button"
            id="favouriteIcon"
            [pTooltip] = getFavouriteToolTip()
            icon="pi pi-star-fill favoriteIconColor"
            class="p-button-rounded p-button-text favoriteIconFilledColor"
            (debounceClick)="updateDocumentFavourite()"
          ></button>
        </div>
  
        <div class="btn">
          <button
            appPreventDoubleClick
            pButton
            pRipple
            type="button"
            id="copyLink"
            icon="fa fa-link"
            class="p-button-rounded p-button-text btnBlueColored btnWidth cursor-pointer "
            pTooltip="Get Document Link"
            (debounceClick)="openDocumentLinkModal()"
          ></button>
        </div>
        <div class="btn">
          <button
            appPreventDoubleClick
            pButton
            pRipple
            type="button"
            id="copyLink"
            icon="fa fa-comment"
            class="p-button-rounded p-button-text btnWidth cursor-pointer "
            [ngClass]=" {'btnBlueColored' : ifCommentsPresent}"
            pTooltip="Document Comments"
            (debounceClick)="openDocumentCommentModal()"
          ></button>
        </div>

        <div class="notification cursor-pointer" (click)="openChangeRequestItemHistoryModal()"
        *ngIf="documentDetail.changeRequestItemCounter && documentDetail.changeRequestItemCounter.changeRequestItemsCount > 0">          
          <span class="fa fa-lightbulb btnBlueColored" pTooltip="Change Request History" id="createChangeRequest"></span>          
          <span  class="notificationSection_Badge"
          pTooltip="Change Request History"
            [ngClass]="
              documentDetail?.changeRequestItemCounter!
                .isAnyChangeRequestItemsNotRejected
                ? 'counter-non-rejected-status'
                : 'counter-rejected-status'"
          >
            {{ documentDetail.changeRequestItemCounter?.changeRequestItemsCount }}            
            </span>
        </div>
      </div>
      <div class="column4">
        
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.checkOutButton">
        <app-document-check-out [documentDetail]="documentDetail"
        (isDocumentCheckoutSuccessful)="reloadDocumentPageOnCheckOut($event)">
        </app-document-check-out>
      </div>
      <div  class="btn">
          <app-next-phase *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.nextPhaseButton"
          (isNextPhaseModalVisible)="displayNextPhaseButton($event)"
          [documentPhase]="documentDetail.phase"
        ></app-next-phase>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.fileCheckInButton">
          <button
            appPreventDoubleClick
            pButton
            pRipple
            class="p-button-outlined"
            tooltipPosition="left"
            icon="fas fa-file-import"
            id="documentCheckinBtn"
            iconPos="left"
            pTooltip="File Check In"
            (debounceClick)="openFileCheckInModal()"
          ></button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.discardCheckOutButton">
          <button
          appPreventDoubleClick
            pButton
            pRipple
            class="p-button-outlined btnBlueColored"
            tooltipPosition="left"
            icon="fas fa-lock-open"
            id="documentCheckinBtn"
            iconPos="left"
            pTooltip="Unlock Document"
            (debounceClick)="confirmDialogForUnlockFile()"
          ></button>
        </div>
        <div class="btn" *ngIf="isFormattedDocumentPreviewButtonVisible">
          <p-button
          appPreventDoubleClick
            styleClass="p-button-outlined"
            pTooltip="Formatted Document Preview"
            tooltipPosition="left"
            icon="fa fa-binoculars"
            id="formattedDocumentPreviewButton"
            iconPos="left"
            (debounceClick)="previewFormattedFile()"
          ></p-button>
        </div>
	      <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.approvalStatusButton">
          <p-button
          appPreventDoubleClick
            pTooltip="Approval Status"
            tooltipPosition="left"
            icon="fas fa-check-circle"
            id="approvalStatusButton"
            iconPos="left"
            (debounceClick)="documentApprovalStatus()"
          ></p-button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.reviewStatusButton">
          <p-button
          appPreventDoubleClick
            pTooltip="Review Status"
            tooltipPosition="left"
            icon="fas fa-eye"
            id="reviewStatusButton"
            iconPos="left"
            (debounceClick)="documentReviewStatus()"
          ></p-button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.editPropertiesButton && editDocumentAvailableForUser">
          <p-button
          appPreventDoubleClick
            styleClass="p-button-outlined"
            icon="fa fa-pen"
            id="editDocumentButton"
            class="edit-document-button"
            pTooltip="Edit Properties"
            tooltipPosition="left"
            iconPos="left"
            (debounceClick)="editDocument()"
          ></p-button>
          <app-document-slider *ngIf="isDocumentSliderOpen"
            [isDocumentSliderOpen]="isDocumentSliderOpen"
            (isDocumentSliderActive)="closeEditDocumentSlider($event)"
            [documentAttachments]="documentAttachments"
            [disableSourceFileSectionOnDcumentCheckout]="displayFileCheckedOutIcon"
            [isFileCheckedOut]="displayFileCheckedOutIcon"
            [isGlobalDocument]="documentDetail.isGlobalDocument"
            [relatedDocuments]="documentDetail.relatedDocuments"
            [isInternalClientContactLimitedAccess]="isInternalClientContactLimitedAccess"
          ></app-document-slider>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.documentProficiencyQuizButton"> 
          <p-button
          appPreventDoubleClick
            styleClass="p-button-outlined"
            icon="fa-solid fa-clipboard-question"
            id="docProficienctQuizButton"
            pTooltip="Proficiency Quiz"
            tooltipPosition="left"
            iconPos="left"
            (debounceClick)="openDocumentProficiencyQuizSlider()"
          ></p-button>
        </div> 
        <div class="btn" *ngIf="documentDetail.isLatestVersion && documentDetail.documentAuthorizationFlags &&
         documentDetail.documentAuthorizationFlags.curriculumTrainingItemGroupManagementButton"> 
          <p-button
            appPreventDoubleClick
            styleClass="p-button-outlined"
            icon="fas fa-building-columns"
            id="curriculumTrainingItemGroupManagementButton"
            pTooltip="Curriculum/Training Item Group Management"
            tooltipPosition="left"
            iconPos="left"
            (debounceClick)="openCurriculumTrainingItemGroupManagementSlider()"
          ></p-button>
        </div> 
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.previousPhaseButton">
          <app-previous-phase
            (isPreviousPhaseModalVisible)="displayPreviousPhaseButton($event)"
          ></app-previous-phase>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.effectiveNowButton">
          <app-update-effective-date-button
            (buttonClick)="openConfirmationModal()"
            [documentVersion]="documentDetail.version"
            [documentNumber]="documentDetail.number"
            [documentVersionPeriodicReviewCycle]="
              documentDetail.periodicReviewCycle
            "
          ></app-update-effective-date-button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.deActivateButton">
          <app-deactivate-button
            (isDeactivationModalVisible)="displayDeactivationModal($event)"
            [documentVersion]="documentDetail.version"
            [documentNumber]="documentDetail.number"
            (setDocumentDetailsLoader)="
            setDocumentLoader($event)
            "
          ></app-deactivate-button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.cancelButton">
          <app-cancel-button
            (isCancellationModalVisible)="displayCancellationReasonModal($event)"
            [documentVersion]="documentDetail.version"
            [documentNumber]="documentDetail.number"
            (setDocumentDetailsLoader)="
            setDocumentLoader($event)
            "
          ></app-cancel-button>
        </div>
        <div class="btn" *ngIf="documentDetail.documentAuthorizationFlags && documentDetail.documentAuthorizationFlags.unCancelButton">
          <app-uncancel-button
            [documentVersion]="documentDetail.version"
            [documentNumber]="documentDetail.number"
            (setDocumentDetailsLoader)="
            setDocumentLoader($event)
            "
          ></app-uncancel-button>
        </div>
        <div class="btn" *ngIf="showDelegateButton">
          <button
          appPreventDoubleClick
            pButton
            pRipple
            class="p-button-outlined btnBlueColored"
            pTooltip="Delegate"
            tooltipPosition="left"
            icon="fas fa-share"
            id="delegateBtn"
            iconPos="left"
            (debounceClick)="addDelegation()"
          ></button>
        </div>
        <div class="btn" *ngIf="documentDetail.isChangeRequestItemVisible">
          <button
          appPreventDoubleClick
            pButton
            pRipple
            icon="fa fa-lightbulb"
            class="p-button-outlined btnBlueColored"
            id="createChangeRequest"
            (debounceClick)="openCreateChangeRequestItem()"
            pTooltip="Change Request Item"
            tooltipPosition="left"
          ></button>
        </div>           
    </div>
  </div>
    <!--ToDo: The max-height will be removed-->
    <div class="bpt-main-content-container">
      <p-tabView [(activeIndex)]="activeIndex">
        <p-tabPanel header="Document Info">
          <p-fieldset legend="Document Summary" [toggleable]="true">
            <div class="grid">
              <div class="col">
                <app-label labelText="{{ 'Version' }}"></app-label>
                <em
                  class="pi pi-history ml-2 blue-color cursor-pointer"
                  (click)="openDocumentVersionHistoryModal()"
                ></em>
                <app-read-only readonlyText="{{ documentDetail.version }}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Phase' }}"></app-label>
                  <div class="grid pt-1">
                    <div class="col max-w-0 pb-0">
                    <em
                    class="pi pi-circle-fill ml-1 mr-1 mt-1"
                    [ngClass]="calculatePhaseColor(documentDetail.phase)"></em>
                  </div>
                <div class="col ml-2 pb-0">
                  <app-read-only readonlyText="{{ documentDetail.phaseName }}"></app-read-only>
                </div>
                </div>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Division' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.division }}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Local Level' }}"></app-label>
                  <app-read-only readonlyText="{{ documentDetail.localLevel }}"></app-read-only>
                
              </div>
            </div>
            <div class="grid">
              <div class="col" *ngIf=isEffectiveDateToBeDisplayed>
                <app-label labelText="{{ 'Effective Date' }}"></app-label>
                  <app-read-only readonlyText="{{
                    documentDetail.effectiveDate | date: 'dd-MMM-yyyy'
                  }}"></app-read-only>
              
              </div>
              <div class="col" *ngIf=isRequestedEffectiveDateToBeDisplayed>
                <app-label labelText="{{ 'Requested Effective Date' }}"></app-label>
              <app-read-only readonlyText = "{{ documentDetail.requestedEffectiveDate | date: 'dd-MMM-yyyy'}}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Periodic Review Cycle' }}"></app-label>
                  <app-read-only readonlyText="{{ documentDetail.periodicReviewCycle }}"></app-read-only>
              </div>
  
              <div class="col">
                <app-label labelText="{{ 'Functional Area' }}"></app-label>
                  <app-read-only readonlyText="{{ documentDetail.functionalArea }}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Local Category' }}"></app-label>
                  <app-read-only readonlyText="{{ documentDetail.localCategory }}"></app-read-only>
              </div>
            </div>
            <div class="grid">
              <div class="col overflow-ellipsis">
                <app-label labelText="{{ 'Legacy Document #' }}"></app-label>
                  <app-read-only readonlyText="{{ documentDetail.legacyDocumentNumber }}" toolTipMessage="{{documentDetail.legacyDocumentNumber}}"></app-read-only>
              
              </div>
              <div class="col">
                <app-label labelText="{{ 'Periodic Review Date' }}"></app-label>
                  <app-read-only readonlyText="{{
                    documentDetail.periodicReviewDate | date: 'dd-MMM-yyyy'
                  }}"></app-read-only>
              
              </div>
              <div class="col">
                <app-label labelText="{{ 'Type' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.documentType }}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Local Type' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.localType }}"></app-read-only>
              </div>
            </div>
            <div class="grid">
              <div class="col mb-2">
                <app-label labelText="{{ 'Classification Level' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.classificationLevel }}"></app-read-only>
              </div>
              <div class="col">
                <app-label labelText="{{ 'Created By' }}"></app-label>
                <app-read-only readonlyText="{{documentDetail.createdBy}}"></app-read-only>
              </div>
              <div class="col"></div>
              <div class="col overflow-ellipsis">
                <app-label labelText="{{ 'Responsible Sub-BU' }}"></app-label>
                <app-read-only readonlyText="{{documentDetail.responsibleSubBusinessUnit}}" toolTipMessage="{{documentDetail.responsibleSubBusinessUnit}}" tooltipPosition="left"></app-read-only>
              </div>
            </div>
            <div class="grid">
              <div class="col" *ngIf="documentDetail.classificationLevel=='Global'">
                <app-label labelText="{{ 'Category' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.category }}"></app-read-only>
              </div>
              <div class="col" *ngIf="documentDetail.classificationLevel=='Local'">
                <app-label labelText="{{ 'Operational Group' }}"></app-label>
                <app-read-only readonlyText="{{ documentDetail.operationalGroup }}"></app-read-only>
              </div>
              <div class="col">
              <app-label labelText="{{ 'Created Date' }}"></app-label>
                  <app-read-only readonlyText="{{
                    documentDetail.createdOn | date: 'dd-MMM-yyyy'
                  }}"></app-read-only>
              </div>
              <div class="col"></div>
              <div class="col"></div>
            </div>
            <div *ngIf = "documentDetail.reason" class="grid">
              <div class="col-9 text-justify pr-5">
                <app-label labelText="Reason"></app-label>
                <app-read-only readonlyText="{{ documentDetail.reason }}"></app-read-only>
              </div>
            </div>
          </p-fieldset>
          <p-fieldset
            legend="Assignments/Permissions"
            [toggleable]="true"
            [collapsed]="true"
          >
            <div class="grid">
              <div class="col-3">
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Author' }}"></app-label>
                    <app-read-only [ngClass]="{'inActiveGroup':documentDetail.author?.isActive===false || documentDetail.author?.isTerminated === true}" readonlyText="{{ documentDetail.author?.assignedUserName }}" toolTipMessage="{{ documentDetail.author?.assignedUserName }}"></app-read-only>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Assigned Admin(s)' }}"></app-label>
                    <div *ngFor="let assignedAdmin of documentDetail.assignedAdmins">
                      <app-read-only [ngClass]="{'inActiveGroup':assignedAdmin.isActive===false || assignedAdmin.isTerminated === true}" readonlyText="{{ assignedAdmin.assignedUserName }}" toolTipMessage="{{ assignedAdmin.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Collaborator(s)' }}"></app-label>
                    <div *ngFor="let collaborator of documentDetail.collaborators">
                      <app-read-only [ngClass]="{'inActiveGroup':collaborator.isActive===false  || collaborator.isTerminated === true}" readonlyText="{{ collaborator.assignedUserName }}" toolTipMessage="{{ collaborator.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Assigned QA(s)' }}"></app-label>
                    <div *ngFor="let assignedQA of documentDetail.assignedQAs">
                      <app-read-only [ngClass]="{'inActiveGroup':assignedQA.isActive===false || assignedQA.isTerminated === true}"  readonlyText="{{ assignedQA.assignedUserName }}" toolTipMessage="{{ assignedQA.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid" *ngIf="documentDetail.includesClientSignature">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Internal Client Contact(s)' }}"></app-label>
                    <div *ngFor="let internalClientContact of documentDetail.internalClientContacts">
                      <app-read-only [ngClass]="{'inActiveGroup':internalClientContact.isActive===false || internalClientContact.isTerminated === true}" readonlyText="{{ internalClientContact.assignedUserName }}" toolTipMessage="{{ internalClientContact.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Assigned Doc Control' }}"></app-label>
                    <div *ngFor="let assignedDocControl of documentDetail.assignedDocControl">
                      <app-read-only [ngClass]="{'inActiveGroup':assignedDocControl.isActive===false || assignedDocControl.isTerminated === true}" readonlyText="{{ assignedDocControl.assignedUserName }}" toolTipMessage="{{ assignedDocControl.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Reviewer(s)' }}"></app-label>
                    <div *ngFor="let reviewer of documentDetail.reviewers">
                      <app-read-only [ngClass]="{'inActiveGroup':reviewer.isActive===false  || reviewer.isTerminated === true}" readonlyText="{{ reviewer.assignedUserName }}" toolTipMessage="{{ reviewer.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Approver(s)' }}"></app-label>
                    <div *ngFor="let approver of documentDetail.approvers">
                      <app-read-only [ngClass]="{'inActiveGroup':approver.isActive===false  || approver.isTerminated === true}" readonlyText="{{ approver.assignedUserName }}" toolTipMessage="{{ approver.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Periodic Reviewer(s)' }}"></app-label>
                    <div
                      *ngFor="
                        let periodicReviewer of documentDetail.periodicReviewers">
                        <app-read-only [ngClass]="{'inActiveGroup':periodicReviewer.isActive===false  || periodicReviewer.isTerminated === true}" readonlyText="{{ periodicReviewer.assignedUserName }}" toolTipMessage="{{ periodicReviewer.assignedUserName }}"></app-read-only>
                    </div>
                  </div>
                </div>
            </div>
              <div class="col-3">
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'Security / Permissions' }}"></app-label>
                    <div class="tags-style"  *ngFor="let securityPermission of documentDetail.securityPermissions">
                      <app-read-only readonlyText="{{securityPermission}}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="grid">
                  <div class="col mb-2">
                    <app-label labelText="{{ 'Confidentiality Level' }}"></app-label>
                    <app-read-only readonlyText="{{ documentDetail.confidentialityLevel }}"></app-read-only>
                  </div>
                 
                </div>
                <div class="grid"></div>
                <div class="grid"></div>
              </div>
              <div class="col-3">
                <div class="grid">
                  <div class="col mb-2 overflow-ellipsis">
                    <app-label labelText="{{ 'eQMS Scope(s)' }}"></app-label>
                    <div *ngFor="let eQMSScope of documentDetail.eQMSScopeNames">
                      <app-read-only readonlyText="{{eQMSScope}}" toolTipMessage="{{ eQMSScope }}"></app-read-only>
                    </div>
                  </div>
                </div>
                <div class="col overflow-ellipsis tags-style">
                  <app-label labelText="{{ 'Tag(s)' }}"></app-label>
                  <div class="tags-style"  *ngFor="let tag of documentDetail.tags">
                    <app-read-only readonlyText="{{tag}}"></app-read-only>
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
          <p-fieldset
            class="mt-1"
            legend="Related Documents"
            [toggleable]="true"
            [collapsed]="true"
            *ngIf="documentDetail.relatedDocuments && documentDetail.relatedDocuments.length > 0"
          >
            <app-related-document-details
              [relatedDocuments]="documentDetail.relatedDocuments"
            ></app-related-document-details>
          </p-fieldset>
          <p-fieldset
            class="mt-1"
            legend="Attachments"
            [toggleable]="true"
            [collapsed]="true"
            *ngIf="isDocumentAttachmentsExists"
          >
            <app-document-attachments
              [documentDetailsDto]="documentDetailsDto"
              [documentAttachments]="documentAttachments"
            ></app-document-attachments>
          </p-fieldset>
          <p-fieldset
          class="mt-1"
          legend="Client Signature Attachment"
          [toggleable]="true"
          [collapsed]="true"
          *ngIf="documentDetail.includesClientSignature"
        >
        <div *ngIf="documentDetail.clientSignatureAttachment != null">
        <em class="blue-color cursor-pointer" (click)="downloadAttachment(documentDetail.clientSignatureAttachment.attachmentFileId!, documentDetail.clientSignatureAttachment.attachmentName!)"
        ><app-file-icon [fileType]="documentDetail.clientSignatureAttachment.attachmentType"></app-file-icon
      ></em>
      <span class="ml-3">{{ documentDetail.clientSignatureAttachment.attachmentName }}</span>
        </div>
        </p-fieldset>
        </p-tabPanel>
        <p-tabPanel header="Hardcopy">
          <app-hard-copy-management
            [documentNumber]="documentDetail.number"
            [documentVersion]="documentDetail.version"
            [documentStatus]="documentDetail.phase"
            [addHardCopyButton]="documentDetail.documentAuthorizationFlags.hardCopyActivityButton"
            [fileId]="fileId"
            [fileName]="fileName"
            *ngIf="activeIndex === 1"
          >
          </app-hard-copy-management>
        </p-tabPanel>
        <p-tabPanel header="Training">
          <app-document-training
          [documentVersion]="documentDetail.version"
          [documentNumber]="documentDetail.number"
          (reloadDocumentDetails) = "reloadDocumentData()"
          [trainingItemGroups] = "trainingItemGroupsForDocument"
           *ngIf="activeIndex === 2">
          </app-document-training>
        </p-tabPanel>
        <p-tabPanel header="Acknowledgement" *ngIf="false">
          <app-acknowledgement-management
            [documentNumber]="documentDetail.number"
            [documentVersion]="documentDetail.version"
            [documentPhaseNumber] ="documentDetail.phase"
            [documentEffectiveDate]="documentDetail.effectiveDate"
            [nextVersionPhase]="documentDetail.nextVersionPhase"
            [isLoggedInUserAdmin]="isLoggedInUserAdmin"
          >
          </app-acknowledgement-management>
        </p-tabPanel>   
        <p-tabPanel header="Audit Trail" *ngIf="documentDetail.isAuditTrailTabAvailable">
          <app-audit-trail 
          [documentNumber]="documentDetail.number"
          [documentVersion]="documentDetail.version"
          *ngIf="activeIndex === 3">            
          </app-audit-trail>
        </p-tabPanel> 
      </p-tabView>
    </div>
  </div>


  <app-change-request-item *ngIf="isCreateChangeRequestItemSliderOpen"
    [isCreateChangeRequestItemSliderOpen]="isCreateChangeRequestItemSliderOpen"
    [documentNumber]="documentDetail.number"
    [documentVersion]="documentDetail.version"
    [documenteQMSScopes]="documentDetail.eQMSScopes"
    (isCreateChangeRequestItemSliderActive)="
      isCreateChangeRequestItemSliderActive($event)
    "
    (setDocumentDetailsLoader) = "setDocumentLoader($event)"
  >
  </app-change-request-item>

  <div *ngIf="isFileCheckinModalShow">
    <app-document-file-checkin (isFileCheckInModalVisible)="displayFileCheckInModal($event)" [documentNumber]="documentDetail.number"
    [documentVersion]="documentDetail.version" [documentDetails]="documentDetail"> </app-document-file-checkin>
  </div>

  <div *ngIf="isReasonForChangeModal">
    <app-document-reason-for-change-modal
      [documentDetailsDto]="documentDetailsDto"
      (isReasonForChangeModalVisible)="displayReasonForChangeModal($event)"
      (setDocumentDetailsLoader)="
        setDocumentLoader($event)
      "
    >
    </app-document-reason-for-change-modal>
  </div>
  <div *ngIf="isChangeRequestHistoryModalShow">
    <app-change-request-history-modal
      [documentDetailsDto]="documentDetailsDto"
      [isChangeRequestHistoryModalShow]="isChangeRequestHistoryModalShow"
      [isLatestVersion]="documentDetail.isLatestVersion"
      [documentPhase]="documentDetail.phaseName"
      (isCloseChangeRequestItemHistoryModal)="closeChangeRequestHistoryModal($event)"
      (isLatestDocument)="updateIsLatestVersion($event)"
      (isAllCRIStatusRejected)="setCRICountButtonColor($event)"
      [showCRIReviewActionButtons]="isCRIReviewActionsAvailable"
      [checkedOutUserStatus] = "getCheckOutUserStatus()"
    >
    </app-change-request-history-modal>
  </div>
  <app-document-version-history
    *ngIf="viewHistoryModal"
    [documentDetailsDto]="documentDetailsDto"
    (isCloseChangeRequestItemHistoryModal)="closeChangeRequestHistoryModal($event)"
    (isLatestDocument)="updateIsLatestVersion($event)"
    (isDocumentHistoryModalShow)="closeDocumentVersionHistoryModal()"
  >
  </app-document-version-history>
  <div *ngIf="isReviewersPanelModal">
    <app-review-status
      (isReviewStatusModalVisible)="displayReviewsPanelModal($event)"
      (setDocumentDetailsLoader)="
        setDocumentLoader($event)
      "
      [documentVersion]="documentDetail.version"
      [documentNumber]="documentDetail.number"
      [documentDetailsDto]="documentDetailsDto"
      [showCompleteButton]="documentDetail.documentAuthorizationFlags.completeButtonInReviewCard"
      [showCompleteButtonWhenFileCheckedOut]="displayFileCheckedOutIcon"
    ></app-review-status>
  </div>
  <div *ngIf="isApproversPanelModal">
    <app-approval-status
      (isApprovalStatusModalVisible)="displayApproversPanelModal($event)"
      (setDocumentDetailsLoader)="
        setDocumentLoader($event)
      "
      [documentVersion]="documentDetail.version"
      [documentNumber]="documentDetail.number"
      [effectiveDate]="documentDetail.effectiveDate"
      [requestedEffectiveDate]="documentDetail.requestedEffectiveDate"
      [periodicReviewDate]="documentDetail.periodicReviewDate"
      [periodicReviewCycle]="documentDetail.periodicReviewCycleValue"
      [showApproveButton]="documentDetail.documentAuthorizationFlags.approveButtonInApprovalCard"
      [showApproveButtonWhenFileCheckedOut]="displayFileCheckedOutIcon"
    ></app-approval-status>
  </div>
  <app-delegation-slider *ngIf="isDelegateSliderOpen"
      [isDelegateSliderOpen]="isDelegateSliderOpen" 
      [isDelegateSliderOpenedFromDocumentDetailPage] = "true"
      [documentNumber] = "documentDetail.number"
      (isDelegateSliderActive)="closeDelegateSlider($event)"
  ></app-delegation-slider>
</div>
<app-document-proficiency-quiz-slider *ngIf="isDocumentProficiencyQuizSliderOpen"
  [documentDetailsDto]="documentDetailsDto"
  [isDocumentProficiencyQuizSliderOpen]="isDocumentProficiencyQuizSliderOpen"
  (isDocumentProficiencyQuizSliderActive)="closeDocumentProficiencyQuizSlider($event)"
  (quizData)="getQuizData($event)">
</app-document-proficiency-quiz-slider>
<app-curriculum-training-item-group-management
    *ngIf="isCurriculumTrainingItemGroupManagementSliderOpen"
    [isCurriculumTrainingItemGroupManagementSliderOpen]="isCurriculumTrainingItemGroupManagementSliderOpen"
    (isCurriculumTrainingItemGroupManagementActive)="closeCurriculumTrainingItemGroupManagementSlider($event)"
    [defaultTrainingItemGroups] = "trainingItemGroupsForDocument"
    [defaultScheduledCurriculums] = "curriculumsForScheduledDocumentTrainingItem"
    [defaultCurriculumsWithActiveDocumentTrainingItem]="curriculumsForActiveDocumentTrainingItem"
    [trainingItemGroupsLookupRequest] = "trainingItemGroupsLookupRequest"
    [curriculumsLookupRequest] ="curriculumsLookupRequest"
    [isTrainingItemGroupDropdownVisible] = "documentDetail.isTrainingItemGroupDropdownVisible"
    [isCurriculumDropdownVisible]="documentDetail.isCurriculumDropdownVisible"
  ></app-curriculum-training-item-group-management>
<ng-template #docNotFound>
  <app-error [errorMessage]="documentErrorMessage()"></app-error>
</ng-template>

<app-confirmation-dialog *ngIf="showLoadDocumentDetailsConfirmationDialog" 
[messageForApprovedAndEffcetivePhases]="loadDocumentDetailsMessage" 
(confirmed)="onLoadDocumentDetailsConfirmed()" 
(dialogClosed)="onDialogClosed($event)">
</app-confirmation-dialog>

<app-dialog *ngIf="showConfirmationModalOnClickOfUpdateEffectiveDateBtn" 
[reasonValidationMessage]="validationMessageForReasonForChangingEffectiveDate"
[heading]="headingForUpdateEffectiveDate"
[confirmationMessage]="confirmationTextForUpdateEffectiveDate"
(saveDocumentwithReason)="saveReason($event)" 
(isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

<div *ngIf="isDocumentVersionDateModalVisible" id="approvalStatusModal">
  <app-document-version-dates
    (closeDocVersionModal)="handleDocVersionDatesModal($event)"
    (setDocumentDetailsLoader)="
        setDocumentLoader($event)
      "
    [docEffectiveDate]="documentDetail.effectiveDate"
    [docRequestedEffectiveDate]="documentDetail.requestedEffectiveDate"
    [docPeriodicReviewCycle]="documentDetail.periodicReviewCycleValue"
    [docPeriodicReviewDate]="documentDetail.periodicReviewDate"
    [documentVersion]="documentDetail.version"
    [documentNumber]="documentDetail.number"
    [isUpdateEffectiveDate]="isDocumentVersionDateModalVisible"
    [reasonForUpdatingEffectiveDate]="reasonForEffectiveDateUpdate"
    [phase]="documentDetail.phase"
    [isEsignDialogForDocumentDetailsUpdate]="displayESignForDocDetailsUpdate"
  >
  </app-document-version-dates>
</div>
